<template>
  <div class="welcome">
    <language-switch class="welcome__language" />
    <transition name="fade" mode="out-in" @before-enter="scrollToTop">
      <router-view />
    </transition>
  </div>
</template>

<script>
import LanguageSwitch from '@/components/LanguageSwitch'

export default {
  name: 'WelcomeLayout',
  components: { LanguageSwitch },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="sass" scoped>
.welcome
  position: relative
  flex-grow: 1
  padding: 36px 20px 20px

.welcome__language
  position: absolute
  top: 18px
  right: 18px
  z-index: 2

.fade-enter-active, .fade-leave-active
  transition: opacity 0.5s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
